import { isAxiosError } from 'axios';

export function getApiError(error: unknown) {
  if (isAxiosError(error)) {
    return {
      message:
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch loan officer',
      status: error.response?.status,
      code: error.code,
    };
  }

  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return {
      message: error.message,
      status: undefined,
      code: undefined,
    };
  }

  return {
    message: 'An unexpected error occurred',
    status: undefined,
    code: undefined,
  };
}
